import { Button, FileUploadOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { BlockedUsersExportModal } from '../blocked-users-export-modal';

export default function AdminExamCourseEnablementButton() {
  const [isOpen, { open, close }] = useDisclosure();

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<FileUploadOutlinedIcon />}
        onClick={open}
      >
        Export
      </Button>
      <BlockedUsersExportModal open={isOpen} onClose={close} />
    </>
  );
}
